"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFilterFromPOJOs = exports.isExtensionFromRawFileSupported = exports.getFileExtensionFromRawFile = exports.addSupportInfoToFiles = exports.isInsertFileDisabled = exports.getIsFileExtensionNotSupported = void 0;

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _FileExtensionFilters = _interopRequireDefault(require("../enums/FileExtensionFilters"));

var _i18n = require("./i18n");

var _fileAccessibility = require("FileManagerCore/utils/fileAccessibility");

var _thumbnailTooltip = require("FileManagerCore/utils/thumbnailTooltip");

var getIsFileExtensionNotSupported = function getIsFileExtensionNotSupported(fileExtension, extensions, filterType) {
  if (filterType === _FileExtensionFilters.default.NONE) return false;
  var isFileInExtensions = extensions.has(fileExtension);
  return filterType === _FileExtensionFilters.default.SUPPORTED ? !isFileInExtensions : isFileInExtensions;
};

exports.getIsFileExtensionNotSupported = getIsFileExtensionNotSupported;

var getNotSupportedReason = function getNotSupportedReason(extensions, reasons, fileExtension, filterType) {
  return reasons.get(fileExtension) || (0, _i18n.getFileFilteringErrorMessage)(extensions, filterType);
};

var isInsertFileDisabled = function isInsertFileDisabled(file, isHostAppContextPrivate) {
  return (0, _fileAccessibility.getIsFileExternal)(file) || (0, _fileAccessibility.getIsFilePrivate)(file) && !isHostAppContextPrivate;
};

exports.isInsertFileDisabled = isInsertFileDisabled;

var addSupportInfoToFiles = function addSupportInfoToFiles(files, filter, isHostAppContextPrivate) {
  var extensions = filter.get('extensions');
  var reasons = filter.get('reasons');
  var filterType = filter.get('filterType');
  return files.map(function (file) {
    if (extensions.count() && filterType !== _FileExtensionFilters.default.NONE) {
      var fileExtension = file.get('extension');
      var notSupported = getIsFileExtensionNotSupported(fileExtension, extensions, filterType);

      if (notSupported) {
        return file.merge({
          notSupported: notSupported,
          notSupportedReason: notSupported && getNotSupportedReason(extensions, reasons, fileExtension, filterType)
        });
      }
    }

    if (isInsertFileDisabled(file, isHostAppContextPrivate)) {
      return file.merge({
        notSupported: true,
        notSupportedReason: _I18n.default.text((0, _thumbnailTooltip.getThumbnailTooltipI18nKey)(file, isHostAppContextPrivate))
      });
    }

    return file;
  });
};

exports.addSupportInfoToFiles = addSupportInfoToFiles;

var getFileExtensionFromRawFile = function getFileExtensionFromRawFile(rawFile) {
  return rawFile.name.split('.').pop();
};

exports.getFileExtensionFromRawFile = getFileExtensionFromRawFile;

var isExtensionFromRawFileSupported = function isExtensionFromRawFileSupported(rawFile, filter) {
  return !getIsFileExtensionNotSupported(getFileExtensionFromRawFile(rawFile), filter.get('extensions'), filter.get('filterType'));
};

exports.isExtensionFromRawFileSupported = isExtensionFromRawFileSupported;

var buildFilterFromPOJOs = function buildFilterFromPOJOs(filterType, filteredExtensions, filteredReasons) {
  return (0, _immutable.Map)({
    extensions: (0, _immutable.Set)(filteredExtensions),
    reasons: (0, _immutable.Map)(filteredReasons),
    filterType: filterType || _FileExtensionFilters.default.NONE
  });
};

exports.buildFilterFromPOJOs = buildFilterFromPOJOs;